import { Component, Input, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() showCompanyLogo :boolean | undefined;
 @Input() companyLogoURL :string | undefined;
 companyTitle:string;
 rpostCompanyLogo:string="../../assets/Images/RPostLogo.gif";
 rportalTpLogo:string="../../assets/Images/tplogo.gif"
  constructor(titleService:Title, router:Router, activatedRoute:ActivatedRoute
    ,private translate: TranslateService) {
    router.events.subscribe(event => {
      if(event instanceof NavigationEnd) {
        var title='';
        var screenURL=window.location.href;
        if(screenURL.indexOf('receipt-authentication')!=-1)
            title = this.translate.instant('ReceiptAuthentication.HeaderTitle'); //this.getTitle(router.routerState, router.routerState.root).join('-');
        else if(screenURL.indexOf('download-authenticated-receipt')!=-1) 
            title = this.translate.instant('DownloadAuthenticatedReceipt.HeaderTitle');
        else if(screenURL.indexOf('receipts/retrieve')!=-1)    
            title = this.translate.instant('DownloadLargeReceipt.HeaderTitle');
        console.log('title', title);
        titleService.setTitle(title);
        this.companyTitle=title;
        
      }
    });

  }

  getTitle(state, parent) {
    var data = [];
    if(parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if(state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  ngOnInit(): void {
  }

  DisplayHeaderTitle(title:string)
  {
    this.companyTitle=title;
  }
}
